import type { InjectionKey } from "vue";

export const CustomTitleSymbol = Symbol("custom-title") as InjectionKey<
  Ref<string>
>;

export const PlatformTourProviderDisplayContext = Symbol(
  "platform-tour-provider-display",
) as InjectionKey<
  Partial<{
    show: Readonly<Ref<boolean>>;
    setShow: (show: boolean) => void;
  }>
>;
